var exports = {
  "W": "VoiceP2pConsentModal.module__points___aW1IZj",
  "m": "VoiceP2pConsentModal.module__checkboxLabel___aW1IZj",
};

module.exports = exports;
